const createBatchStyle = theme => (
    { firstLabel: { paddingBottom: theme.spacing(2) } }
);

export default createBatchStyle;
